<template>
    <div>
        <div class="table-wrapper on-991" v-if="$i18n.locale=='en'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td colspan="2"><span class="invisible">asdf</span></td>
                            <td colspan="4" class="text-center text-white font-weight-bold">ECL STAGING</td>
                        </tr>
                        <tr class="med-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="text-right text-white font-weight-bold">STAGE 1</td>
                            <td class="text-right text-white font-weight-bold">STAGE 2</td>
                            <td class="text-right text-white font-weight-bold">STAGE 3</td>
                            <td class="text-right text-white font-weight-bold">SIMPLIFIED APPROACH</td>
                            <td><span class="invisible">asdf</span></td>
                        </tr>
                        <tr class="light-gray">
                            <td colspan="5"><span class="invisible">asdf</span></td>
                            <td class="text-right text-white font-weight-bold">KD ’000</td>
                        </tr>
                        <tr class="ligest-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="text-right text-white font-weight-bold">12-MONTH</td>
                            <td class="text-right text-white font-weight-bold">LIFETIME</td>
                            <td class="text-right text-white font-weight-bold">LIFETIME</td>
                            <td class="text-right text-white font-weight-bold">LIFETIME</td>
                            <td class="text-right text-white font-weight-bold">TOTAL</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="blueColor" colspan="6">At 31 December 2020</td>
                        </tr>
                        <tr>
                            <td class="blueColor">Cash and bank balances</td>
                            <td class="text-right">292,628</td>
                            <td class="text-right">83,082</td>
                            <td class="text-right">35,323</td>
                            <td class="text-right">-</td>
                            <td class="text-right">411,033</td>
                        </tr>
                        <tr>
                            <td >Less: ECL</td>
                            <td class="text-right">(664)</td>
                            <td class="text-right">(1,413)</td>
                            <td class="text-right">(15,896)</td>
                            <td class="text-right">-</td>
                            <td class="text-right">(17,973)</td>
                        </tr>
                        <tr class="dark-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="text-right text-white font-weight-bold">291,964</td>
                            <td class="text-right text-white font-weight-bold">81,669</td>
                            <td class="text-right text-white font-weight-bold">19,427</td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">393,060</td>
                        </tr>
                        <tr>
                            <td class="blueColor">Customers</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">306,264</td>
                            <td class="text-right">306,264</td>
                        </tr>
                        <tr>
                            <td class="blueColor">Distributors</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">42,282</td>
                            <td class="text-right">42,282</td>
                        </tr>
                        <tr>
                            <td class="blueColor">Contract assets</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">97,298</td>
                            <td class="text-right">97,298</td>
                        </tr>
                        <tr>
                            <td>Less: ECL</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">(191,200)</td>
                            <td class="text-right">(191,200)</td>
                        </tr>
                        <tr class="dark-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">254,644</td>
                            <td class="text-right text-white font-weight-bold">254,644</td>
                        </tr>
                        <tr>
                            <td class="blueColor">Roaming partners</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">7,894</td>
                            <td class="text-right">7,894</td>
                        </tr>
                        <tr>
                            <td class="blueColor">Other operators (interconnect)</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">61,177</td>
                            <td class="text-right">61,177</td>
                        </tr>
                        <tr>
                            <td >Less: ECL</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">(6,847)</td>
                            <td class="text-right">(6,847)</td>
                        </tr>
                        <tr class="dark-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">62,224</td>
                            <td class="text-right text-white font-weight-bold">62,224</td>
                        </tr>
                        <tr>
                            <td class="blueColor">Other receivables</td>
                            <td class="text-right">-</td>
                            <td class="text-right">46,907</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">46,907</td>
                        </tr>
                        <tr>
                            <td>Less: ECL</td>
                            <td class="text-right">-</td>
                            <td class="text-right">(2,699)</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">(2,699)</td>
                        </tr>
                        <tr class="dark-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">44,208</td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">44,208</td>
                        </tr>
                        <tr>
                            <td class="blueColor">Financial guarantees</td>
                            <td class="text-right">-</td>
                            <td class="text-right">7,288</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">7,288</td>
                        </tr>
                        <tr>
                            <td>Less: ECL</td>
                            <td class="text-right">-</td>
                            <td class="text-right">(1,050)</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">(1,050)</td>
                        </tr>
                        <tr class="dark-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">6,238</td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">6,238</td>
                        </tr>
                        <tr>
                            <td class="blueColor">At 31 December 2019</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                        </tr>
                        <tr>
                            <td class="blueColor">Cash and bank balances</td>
                            <td class="text-right">239,832</td>
                            <td class="text-right">40,141</td>
                            <td class="text-right">33,642</td>
                            <td class="text-right">-</td>
                            <td class="text-right">313,615</td>
                        </tr>
                        <tr>
                            <td >Less: ECL</td>
                            <td class="text-right">(93)</td>
                            <td class="text-right">(1,287)</td>
                            <td class="text-right">(15,250)</td>
                            <td class="text-right">-</td>
                            <td class="text-right">(16,630)</td>
                        </tr>
                        <tr class="dark-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="text-right text-white font-weight-bold">239,739</td>
                            <td class="text-right text-white font-weight-bold">38,854</td>
                            <td class="text-right text-white font-weight-bold">18,392</td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">296,985</td>
                        </tr>
                        <tr>
                            <td class="blueColor">Customers</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">294,906</td>
                            <td class="text-right">294,906</td>
                        </tr>
                        <tr>
                            <td class="blueColor">Distributors</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">43,909</td>
                            <td class="text-right">43,909</td>
                        </tr>
                        <tr>
                            <td class="blueColor">Contract assets</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">98,081</td>
                            <td class="text-right">98,081</td>
                        </tr>
                        <tr>
                            <td >Less: ECL</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">(158,662)</td>
                            <td class="text-right">(158,662)</td>
                        </tr>
                        <tr class="dark-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">278,234</td>
                            <td class="text-right text-white font-weight-bold">278,234</td>
                        </tr> 
                        <tr>
                            <td class="blueColor">Roaming partners</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">10,408</td>
                            <td class="text-right">10,408</td>
                        </tr>
                        <tr>
                            <td class="blueColor">Other operators (interconnect)</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">48,004</td>
                            <td class="text-right">48,004</td>
                        </tr>
                        <tr>
                            <td >Less: ECL</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">(8,668)</td>
                            <td class="text-right">(8,668)</td>
                        </tr>
                        <tr class="dark-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">49,744</td>
                            <td class="text-right text-white font-weight-bold">49,744</td>
                        </tr>
                        <tr>
                            <td class="blueColor">Other receivables</td>
                            <td class="text-right">-</td>
                            <td class="text-right">34,633</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">34,633</td>
                        </tr>
                        <tr>
                            <td >Less: ECL</td>
                            <td class="text-right">-</td>
                            <td class="text-right">(2,071)</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">(2,071)</td>
                        </tr>
                        <tr class="dark-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">32,562</td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">32,562</td>
                        </tr>
                        <tr>
                            <td class="blueColor">Financial guarantees</td>
                            <td class="text-right">-</td>
                            <td class="text-right">7,269</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">7,269</td>
                        </tr>
                        <tr>
                            <td >Less: ECL</td>
                            <td class="text-right">-</td>
                            <td class="text-right">(1,050)</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">(1,050)</td>
                        </tr>
                        <tr class="dark-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">6,219</td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">6,219</td>
                        </tr>
                    </tbody>    
                </table>
            </div>
        </div>

        <!-- Arabic -->

        <div class="table-wrapper on-991" v-if="$i18n.locale=='ar'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td colspan="2"><span class="invisible">asdf</span></td>
                            <td colspan="4" class="text-center text-white font-weight-bold">مراحل الخسائر الائتمانية المتوقعة</td>
                        </tr>
                        <tr class="med-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="text-right text-white font-weight-bold">المرحلة 1</td>
                            <td class="text-right text-white font-weight-bold">المرحلة 2</td>
                            <td class="text-right text-white font-weight-bold">المرحلة 3</td>
                            <td class="text-right text-white font-weight-bold">المنهج المبسط</td>
                            <td><span class="invisible">asdf</span></td>
                        </tr>
                        <tr class="light-gray">
                            <td colspan="5"><span class="invisible">asdf</span></td>
                            <td class="text-right text-white font-weight-bold">ألف دينار كويتي</td>
                        </tr>
                        <tr class="ligest-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="text-right text-white font-weight-bold">12 شهراً</td>
                            <td class="text-right text-white font-weight-bold">خلال عمر الأداة</td>
                            <td class="text-right text-white font-weight-bold">خلال عمر الأداة</td>
                            <td class="text-right text-white font-weight-bold">خلال عمر الأداة</td>
                            <td class="text-right text-white font-weight-bold">المجموع</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="blueColor" colspan="6">31 ديسمبر 2020</td>
                        </tr>
                        <tr>
                            <td class="blueColor">النقد والأرصدة البنكية</td>
                            <td class="text-right">292,628</td>
                            <td class="text-right">83,082</td>
                            <td class="text-right">35,323</td>
                            <td class="text-right">-</td>
                            <td class="text-right">411,033</td>
                        </tr>
                        <tr>
                            <td >ناقصاً: الخسارة الائتمانية المتوقعة</td>
                            <td class="text-right">(664)</td>
                            <td class="text-right">(1,413)</td>
                            <td class="text-right">(15,896)</td>
                            <td class="text-right">-</td>
                            <td class="text-right">(17,973)</td>
                        </tr>
                        <tr class="dark-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="text-right text-white font-weight-bold">291,964</td>
                            <td class="text-right text-white font-weight-bold">81,669</td>
                            <td class="text-right text-white font-weight-bold">19,427</td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">393,060</td>
                        </tr>
                        <tr>
                            <td class="blueColor">عملاء</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">306,264</td>
                            <td class="text-right">306,264</td>
                        </tr>
                        <tr>
                            <td class="blueColor">موزعون</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">42,282</td>
                            <td class="text-right">42,282</td>
                        </tr>
                        <tr>
                            <td class="blueColor">أصول العقد</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">97,298</td>
                            <td class="text-right">97,298</td>
                        </tr>
                        <tr>
                            <td>ناقصاً: الخسارة الائتمانية المتوقعة</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">(191,200)</td>
                            <td class="text-right">(191,200)</td>
                        </tr>
                        <tr class="dark-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">254,644</td>
                            <td class="text-right text-white font-weight-bold">254,644</td>
                        </tr>
                        <tr>
                            <td class="blueColor">شركاء التجوال</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">7,894</td>
                            <td class="text-right">7,894</td>
                        </tr>
                        <tr>
                            <td class="blueColor">مشغلون آخرون (الربط البيني)</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">61,177</td>
                            <td class="text-right">61,177</td>
                        </tr>
                        <tr>
                            <td>ناقصاً: الخسارة الائتمانية المتوقعة</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">(6,847)</td>
                            <td class="text-right">(6,847)</td>
                        </tr>
                        <tr class="dark-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">62,224</td>
                            <td class="text-right text-white font-weight-bold">62,224</td>
                        </tr>
                        <tr>
                            <td class="blueColor">ذمم مدينة أخرى</td>
                            <td class="text-right">-</td>
                            <td class="text-right">46,907</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">46,907</td>
                        </tr>
                        <tr>
                            <td>ناقصاً: الخسارة الائتمانية المتوقعة</td>
                            <td class="text-right">-</td>
                            <td class="text-right">(2,699)</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">(2,699)</td>
                        </tr>
                        <tr class="dark-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">44,208</td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">44,208</td>
                        </tr>
                        <tr>
                            <td class="blueColor">ضمانات مالية</td>
                            <td class="text-right">-</td>
                            <td class="text-right">7,288</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">7,288</td>
                        </tr>
                        <tr>
                            <td>ناقصاً: الخسارة الائتمانية المتوقعة</td>
                            <td class="text-right">-</td>
                            <td class="text-right">(1,050)</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">(1,050)</td>
                        </tr>
                        <tr class="dark-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">6,238</td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">6,238</td>
                        </tr>
                        <tr>
                            <td class="blueColor">31 ديسمبر 2019</td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                        </tr>
                        <tr>
                            <td class="blueColor">النقد والأرصدة البنكية</td>
                            <td class="text-right">239,832</td>
                            <td class="text-right">40,141</td>
                            <td class="text-right">33,642</td>
                            <td class="text-right">-</td>
                            <td class="text-right">313,615</td>
                        </tr>
                        <tr>
                            <td>ناقصاً: الخسارة الائتمانية المتوقعة</td>
                            <td class="text-right">(93)</td>
                            <td class="text-right">(1,287)</td>
                            <td class="text-right">(15,250)</td>
                            <td class="text-right">-</td>
                            <td class="text-right">(16,630)</td>
                        </tr>
                        <tr class="dark-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="text-right text-white font-weight-bold">239,739</td>
                            <td class="text-right text-white font-weight-bold">38,854</td>
                            <td class="text-right text-white font-weight-bold">18,392</td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">296,985</td>
                        </tr>
                        <tr>
                            <td class="blueColor">عملاء</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">294,906</td>
                            <td class="text-right">294,906</td>
                        </tr>
                        <tr>
                            <td class="blueColor">موزعون</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">43,909</td>
                            <td class="text-right">43,909</td>
                        </tr>
                        <tr>
                            <td class="blueColor">أصول العقد</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">98,081</td>
                            <td class="text-right">98,081</td>
                        </tr>
                        <tr>
                            <td>ناقصاً: الخسارة الائتمانية المتوقعة</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">(158,662)</td>
                            <td class="text-right">(158,662)</td>
                        </tr>
                        <tr class="dark-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">278,234</td>
                            <td class="text-right text-white font-weight-bold">278,234</td>
                        </tr> 
                        <tr>
                            <td class="blueColor">شركاء التجوال</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">10,408</td>
                            <td class="text-right">10,408</td>
                        </tr>
                        <tr>
                            <td class="blueColor">مشغلون آخرون (الربط البيني)</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">48,004</td>
                            <td class="text-right">48,004</td>
                        </tr>
                        <tr>
                            <td>ناقصاً: الخسارة الائتمانية المتوقعة</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">(8,668)</td>
                            <td class="text-right">(8,668)</td>
                        </tr>
                        <tr class="dark-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">49,744</td>
                            <td class="text-right text-white font-weight-bold">49,744</td>
                        </tr>
                        <tr>
                            <td class="blueColor">ذمم مدينة أخرى</td>
                            <td class="text-right">-</td>
                            <td class="text-right">34,633</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">34,633</td>
                        </tr>
                        <tr>
                            <td>ناقصاً: الخسارة الائتمانية المتوقعة</td>
                            <td class="text-right">-</td>
                            <td class="text-right">(2,071)</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">(2,071)</td>
                        </tr>
                        <tr class="dark-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">32,562</td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">32,562</td>
                        </tr>
                        <tr>
                            <td class="blueColor">ضمانات مالية</td>
                            <td class="text-right">-</td>
                            <td class="text-right">7,269</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">7,269</td>
                        </tr>
                        <tr>
                            <td>ناقصاً: الخسارة الائتمانية المتوقعة</td>
                            <td class="text-right">-</td>
                            <td class="text-right">(1,050)</td>
                            <td class="text-right">-</td>
                            <td class="text-right">-</td>
                            <td class="text-right">(1,050)</td>
                        </tr>
                        <tr class="dark-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">6,219</td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">-</td>
                            <td class="text-right text-white font-weight-bold">6,219</td>
                        </tr>
                    </tbody>    
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:"last__One"
}
</script>

<style>

</style>